const notificationItems = [
  {   
    title: "AWS S3 V2 connector v1.4.2",
    content: "<p>The AWS S3 V2 connector is updated to v1.4.2. This release fixes a bug where recrawls were failing. For more information, see <span class='underline'><a href='/fusion-connectors/4/release-notes?ref=notif'>Connectors release notes</a></span>.</p>"
  },
  {
    title: "Fusion 5.9.12 General Release",
    content: "<p>The Fusion 5.9.12 maintenance release introduces support for chunking in Lucidworks AI, model hosting with Ray, and important security upgrades and bug fixes. For more information, see the <span class='underline'><a href='/fusion/5.9/lt4m82/fusion-5-9-12?ref=notif'>Fusion 5.9.12 release notes</a></span>.</p>"
  },
  {   
    title: "REST V2 connector v1.1.0",
    content: "<p>The REST V2 connector is upgraded to v1.1.0. This release adds new features to improve the connector's ability to locate, collect, and parse content. For more information, see <span class='underline'><a href='/fusion-connectors/4/release-notes?ref=notif'>Connectors release notes</a></span>.</p>"
  },
  {
    title: "Fusion 5.9.11 General Release",
    content: "<p>The Fusion 5.9.11 maintenance release delivers KNN-based performance enhancements for Neural Hybrid Search, Java 17 support for connectors, a new asynchronous parsing service, the Apps Manager API, and critical security updates. For more information, see the <span class='underline'><a href='/fusion/5.9/z72wlm/fusion-5-9-11?ref=notif'>Fusion 5.9.11 release notes</a></span>.</p>"
  }
]

module.exports = {
  notificationItems
}
